import { createContext } from 'react';
import { ClientBankAccountsLists } from 'vopay';

export type SingleCollectionBankInfoCtx = {
  bankAccount?: ClientBankAccountsLists;
  updateBankAccount: (bankAccount?: ClientBankAccountsLists) => void;
};

const SingleCollectionBankInfoContext = createContext<SingleCollectionBankInfoCtx>({
  bankAccount: {
    ABARoutingNumber: '',
    AccountHolderName: '',
    AccountNumber: '',
    Address: '',
    BankID: '',
    BranchTransitNumber: '',
    City: '',
    ClientAccountID: '',
    ClientControlledBankAccount: '',
    ClientReferenceNumber: '',
    Currency: '',
    DateAdded: '',
    EmailAddress: '',
    FinancialInstitutionNumber: '',
    FlinksAccountID: '',
    FlinksLoginID: '',
    InstitutionName: '',
    InveriteRequestGUID: '',
    IsDefault: '',
    Phone: '',
    PlaidAccountID: '',
    'PostalCode/ZipCode': '',
    'Province/State': '',
    Token: '',
    FiservToken: '',
    IntegrationType: '',
    MxAuthorizationCode: '',
    MxProcessorToken: '',
    PlaidProcessorToken: '',
  },
  updateBankAccount: () => {},
});

export default SingleCollectionBankInfoContext;
